import { createContext, useContext, useState, useEffect, useRef } from 'react';
import { Modal, Loader, Text, Stack } from '@mantine/core';
import api from './api';

// ============================================================
// CONTEXT
// ============================================================

const LoadingContext = createContext({ loading: false });

export const useGlobalLoading = () => useContext(LoadingContext);

// ============================================================
// PROVIDER + OVERLAY
// ============================================================

export default function GlobalLoaderProvider({ children }) {
  const [activeRequests, setActiveRequests] = useState(0);
  const interceptorsRef = useRef(null);

  useEffect(() => {
    // Agregar interceptores solo una vez
    const reqInterceptor = api.interceptors.request.use(
      (config) => {
        setActiveRequests((prev) => prev + 1);
        return config;
      },
      (error) => {
        setActiveRequests((prev) => Math.max(0, prev - 1));
        return Promise.reject(error);
      }
    );

    const resInterceptor = api.interceptors.response.use(
      (response) => {
        setActiveRequests((prev) => Math.max(0, prev - 1));
        return response;
      },
      (error) => {
        setActiveRequests((prev) => Math.max(0, prev - 1));
        return Promise.reject(error);
      }
    );

    interceptorsRef.current = { reqInterceptor, resInterceptor };

    return () => {
      api.interceptors.request.eject(reqInterceptor);
      api.interceptors.response.eject(resInterceptor);
    };
  }, []);

  const loading = activeRequests > 0;

  return (
    <LoadingContext.Provider value={{ loading }}>
      {children}

      {/* Overlay modal */}
      <Modal
        opened={loading}
        onClose={() => {}}
        withCloseButton={false}
        closeOnClickOutside={false}
        closeOnEscape={false}
        centered
        size="xs"
        overlayProps={{ backgroundOpacity: 0.4, blur: 2 }}
        styles={{
          body: { padding: '2rem' },
          content: { borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.12)' },
        }}
      >
        <Stack align="center" gap="md">
          <Loader size="lg" color="#020C41" />
          <Text size="sm" c="dimmed" fw={500}>Cargando...</Text>
        </Stack>
      </Modal>
    </LoadingContext.Provider>
  );
}
